import React from "react";
import { RouteObject } from "react-router-dom";

import { EXPERIMENT_ROUTES } from "../../routes";

export const ExperimentNonPaddedRoutes: RouteObject[] = [
  {
    path: EXPERIMENT_ROUTES.Experiment,
    lazy: async () => {
      const { ExperienceWrapperRoute } =
        await import("@src/features/experiments/pages/ExperienceWrapper.route");
      const { ScopedRoute } =
        await import("@src/components/LimitAccess/ScopedRoute");

      return {
        element: (
          <ScopedRoute
            debugId={EXPERIMENT_ROUTES.Experiment}
            isEnabled={() => true}
            children={ExperienceWrapperRoute}
          />
        ),
      };
    },
  },
  {
    path: EXPERIMENT_ROUTES.Experiment_Id,
    lazy: async () => {
      const { ExperienceWrapperRoute } =
        await import("@src/features/experiments/pages/ExperienceWrapper.route");
      const { ScopedRoute } =
        await import("@src/components/LimitAccess/ScopedRoute");

      return {
        element: (
          <ScopedRoute
            debugId={EXPERIMENT_ROUTES.Experiment_Id}
            isEnabled={() => true}
            children={ExperienceWrapperRoute}
          />
        ),
      };
    },
  },
];
